module.exports = "/packs/images/social_society--mobile~5189dcc7f6e5e3236688f5aef60312f8.gif";